module.exports = __webpack_public_path__ + "static/media/logo-stg1.1c513c22.svg";